import { theme } from 'Assets/Styles/theme'

const style = {
  betaLabel: {
    '& span': {
      background: theme.colors.primary,
      color: theme.colors.white,
      borderRadius: '10px',
      padding: '2px 8px',
      margin: '0 4px',
      fontSize: '10px',
    },
  },
}

export default style
